export default __webpack_public_path__ + "static/iphone-02-ed4fb6f05b5fb98b275fbb871d22e8f7.png";